import { render, staticRenderFns } from "./ListBagianLab.vue?vue&type=template&id=fea8f62a"
import script from "./ListBagianLab.vue?vue&type=script&lang=js"
export * from "./ListBagianLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports